export const manifest = {
  screens: {
    scr_uzr6mh: { name: "Home", route: "/", position: {"x":160,"y":1820} },
    scr_udqti2: { name: "Products", route: "/products", position: {"x":1560,"y":1820} },
    scr_bq5hrr: { name: "Product Detail", route: "/product/apple-airpods-pro-2nd-gen", position: {"x":2960,"y":1820} },
    scr_ds51ch: { name: "Cart – Empty", route: "/cart", position: {"x":160,"y":3800} },
    scr_gzapt6: { name: "Cart", route: "/cart", state: {"cartSeed":true}, position: {"x":1560,"y":3800} },
    scr_u2ssay: { name: "Checkout – Card", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"card"}, position: {"x":160,"y":5780} },
    scr_qpkvds: { name: "Checkout – RAAST", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"raast","raastSubMethod":"qr"}, position: {"x":1560,"y":5780} },
    scr_ekedeb: { name: "Checkout – PayVay Wallet", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"payvay"}, position: {"x":2960,"y":5780} },
    scr_3fd6ke: { name: "Card – Payment Details", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"card","modalOpen":true,"paymentStep":"details"}, position: {"x":160,"y":7760} },
    scr_bd93ex: { name: "Card – OTP", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"card","modalOpen":true,"paymentStep":"otp"}, position: {"x":1560,"y":7760} },
    scr_wmrjyy: { name: "Card – Processing", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"card","modalOpen":true,"paymentStep":"processing"}, position: {"x":2960,"y":7760} },
    scr_s015kl: { name: "RAAST QR – Scan to Pay", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"raast","raastSubMethod":"qr","modalOpen":true}, position: {"x":160,"y":9740} },
    scr_6qkgfe: { name: "RAAST RTP – Enter Details", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"raast","raastSubMethod":"rtp","modalOpen":true,"rtpStep":"input"}, position: {"x":1560,"y":9740} },
    scr_4g7j9s: { name: "RAAST RTP – Confirm Account", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"raast","raastSubMethod":"rtp","modalOpen":true,"rtpStep":"confirm"}, position: {"x":2960,"y":9740} },
    scr_4jtkl5: { name: "RAAST RTP – Awaiting Approval", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"raast","raastSubMethod":"rtp","modalOpen":true,"rtpStep":"waiting"}, position: {"x":4360,"y":9740} },
    scr_66k1f9: { name: "PayVay – Enter Wallet", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"payvay","modalOpen":true,"payvayStep":"input"}, position: {"x":160,"y":11720} },
    scr_3ujup5: { name: "PayVay – Awaiting Approval", route: "/checkout", state: {"cartSeed":true,"paymentMethod":"payvay","modalOpen":true,"payvayStep":"waiting"}, position: {"x":1836.27,"y":11782.53} },
    scr_5n0khr: { name: "Payment Receipt", route: "/order-confirmation", state: {"order":"paid"}, position: {"x":160,"y":13700} },
    scr_0nq8jl: { name: "Order Confirmed – COD", route: "/order-confirmation", state: {"order":"cod"}, position: {"x":1560,"y":13700} },
    scr_1nnsj2: { name: "Login", route: "/login", position: {"x":160,"y":15680} },
    scr_vrncwn: { name: "Register", route: "/register", position: {"x":1560,"y":15680} },
    scr_iew7yg: { name: "My Account", route: "/account", state: {"loggedIn":true}, position: {"x":160,"y":17660} },
    scr_azx64c: { name: "About", route: "/about", position: {"x":160,"y":19640} },
    scr_050zfh: { name: "Contact", route: "/contact", position: {"x":1560,"y":19640} },
    scr_xxzx9b: { name: "Contact – Message Sent", route: "/contact", state: {"contactSubmitted":true}, position: {"x":2960,"y":19640} },
    scr_vv4m8i: { name: "FAQ", route: "/faq", position: {"x":4360,"y":19640} },
    scr_f2zjrt: { name: "Standalone Payment Gateway", route: "/payment", position: {"x":0,"y":0}, isDefaultRow: true },
    scr_g6hk0u: { name: "Admin Dashboard", route: "/admin", position: {"x":1400,"y":0}, isDefaultRow: true },
  },
  sections: {
    sec_9jbutz: { name: "Home & Product Browsing", x: 0, y: 1600, width: 4320, height: 1180 },
    sec_jgns8b: { name: "Shopping Cart", x: 0, y: 3580, width: 2920, height: 1180 },
    sec_49cnun: { name: "Checkout – Payment Method Selection", x: 0, y: 5560, width: 4320, height: 1180 },
    sec_u8wc0s: { name: "Card Payment Flow", x: 0, y: 7540, width: 4320, height: 1180 },
    sec_vagcdt: { name: "RAAST Payment Flow", x: 0, y: 9520, width: 5720, height: 1180 },
    sec_j6to95: { name: "PayVay Wallet Flow", x: 0, y: 11500, width: 2920, height: 1180 },
    sec_fk1u9s: { name: "Order Confirmation", x: 0, y: 13480, width: 2920, height: 1180 },
    sec_8jmaar: { name: "Authentication", x: 0, y: 15460, width: 2920, height: 1180 },
    sec_gb0wy6: { name: "User Account", x: 0, y: 17440, width: 1520, height: 1180 },
    sec_lyho8c: { name: "Information & Support", x: 0, y: 19420, width: 5720, height: 1180 },
  },
  layers: [
    { kind: "screen", id: "scr_f2zjrt" },
    { kind: "screen", id: "scr_g6hk0u" },
    { kind: "section", id: "sec_9jbutz", children: [
      { kind: "screen", id: "scr_uzr6mh" },
      { kind: "screen", id: "scr_udqti2" },
      { kind: "screen", id: "scr_bq5hrr" },
    ] },
    { kind: "section", id: "sec_jgns8b", children: [
      { kind: "screen", id: "scr_ds51ch" },
      { kind: "screen", id: "scr_gzapt6" },
    ] },
    { kind: "section", id: "sec_49cnun", children: [
      { kind: "screen", id: "scr_u2ssay" },
      { kind: "screen", id: "scr_qpkvds" },
      { kind: "screen", id: "scr_ekedeb" },
    ] },
    { kind: "section", id: "sec_u8wc0s", children: [
      { kind: "screen", id: "scr_3fd6ke" },
      { kind: "screen", id: "scr_bd93ex" },
      { kind: "screen", id: "scr_wmrjyy" },
    ] },
    { kind: "section", id: "sec_vagcdt", children: [
      { kind: "screen", id: "scr_s015kl" },
      { kind: "screen", id: "scr_6qkgfe" },
      { kind: "screen", id: "scr_4g7j9s" },
      { kind: "screen", id: "scr_4jtkl5" },
    ] },
    { kind: "section", id: "sec_j6to95", children: [
      { kind: "screen", id: "scr_66k1f9" },
      { kind: "screen", id: "scr_3ujup5" },
    ] },
    { kind: "section", id: "sec_fk1u9s", children: [
      { kind: "screen", id: "scr_5n0khr" },
      { kind: "screen", id: "scr_0nq8jl" },
    ] },
    { kind: "section", id: "sec_8jmaar", children: [
      { kind: "screen", id: "scr_1nnsj2" },
      { kind: "screen", id: "scr_vrncwn" },
    ] },
    { kind: "section", id: "sec_gb0wy6", children: [
      { kind: "screen", id: "scr_iew7yg" },
    ] },
    { kind: "section", id: "sec_lyho8c", children: [
      { kind: "screen", id: "scr_azx64c" },
      { kind: "screen", id: "scr_050zfh" },
      { kind: "screen", id: "scr_xxzx9b" },
      { kind: "screen", id: "scr_vv4m8i" },
    ] },
  ],
}
